module.exports = __webpack_public_path__ + "img/spec.95ba2792.jpg";